export default __webpack_public_path__ + "static/media/b67.346a4a02.png";